module.exports = __webpack_public_path__ + "img/applyhead04.a9ba8e4a.webp";